import { render, staticRenderFns } from "./RemitterGroupManagement.vue?vue&type=template&id=44f0483f"
import script from "./RemitterGroupManagement.vue?vue&type=script&lang=js"
export * from "./RemitterGroupManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports